import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';
import { useLoading } from '../../components/LoadingProvider';
import { showError } from '../../utils/toast';
import { getPublicImgUrl } from '../../utils/common';

function SpecializationList() {
    document.title = 'Varosa - Specialization List';
    const { setIsLoading } = useLoading();
    const [specializationList, setSpecializationList] = useState([]);
    useEffect(() => {
        setIsLoading(true);
        api.get('/specialization/all').then((response) => {
            if (response?.data?.result === 'success') {
                setSpecializationList(response?.data?.data?.specializations || []);
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError(response.data?.message || 'An error occurred');
            }
        }).catch((error) => {
            showError(error.message);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);
    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{maxWidth: '900px'}}>
                    <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">Specialization List</h3>
                    <ol className="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item active text-primary">Specialization List</li>
                    </ol>
                </div>
            </div>
            {/* Header End */}

            <div className="container-fluid team py-5">
                <div className="container py-5">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Specialization List</h4>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {specializationList.map((item, index, arr) => (
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s" key={item?.slug}>
                            <div className="service-item rounded">
                                <div className="service-img rounded-top">
                                    <img src={item?.image} className="img-fluid rounded-top w-100" alt="" />
                                </div>
                                <div className="service-content rounded-bottom bg-light p-4">
                                    <div className="service-content-inner">
                                        <h5 className="mb-4">{item?.name || 'Period doubts or Pregnancy'}</h5>
                                        <p className="mb-4">{item?.description || 'Get expert guidance on your period, pregnancy, or other health concerns.'}</p>
                                        <Link to={`/specialization/${item?.slug}/doctors`} className="btn btn-primary rounded-pill text-white py-2 px-4 mb-2">FIND DOCTORS</Link>
                                    </div>
                                </div>
                            </div>
                        </div>))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default SpecializationList;